import { ref } from 'vue';

/** Bumped after collect/redeem so profile, collection page, etc. can refetch. */
export const stickerCollectionProgressVersion = ref(0);

export function notifyStickerCollectionProgressChanged() {
  stickerCollectionProgressVersion.value += 1;
}

export interface AfterStickerWallCollectOptions {
  stickerId?: string;
  fetchCollections?: (stickerId: string) => Promise<void>;
  checkPurchased?: () => Promise<void>;
  refreshPurchasedCache?: () => Promise<void>;
}

/** Refetch sticker-detail collections + purchased state, then notify global listeners. */
export async function afterStickerWallCollectRefresh(
  options: AfterStickerWallCollectOptions,
) {
  const {
    stickerId,
    fetchCollections,
    checkPurchased,
    refreshPurchasedCache,
  } = options;

  if (stickerId && fetchCollections) {
    await fetchCollections(stickerId);
  }
  if (checkPurchased) {
    await checkPurchased();
  }
  if (refreshPurchasedCache) {
    await refreshPurchasedCache();
  }
  notifyStickerCollectionProgressChanged();
}
